
/**
 * 응답 데이터
 * @nullable
 */
export type ActivateSubscription200Data = { [key: string]: unknown } | null;
